import AdminDashboard from "../../views/Admin/AdminDashboard";
import AccreditingBody from "../../views/Admin/AccreditingBody";
import InstitutionCategory from "../../views/Admin/InstitutionCategory";
import {
  ACCREDITATIONS_PATH,
  ACADEMIC_PROGRAM_PATH,
  ACCREDITING_BODIES_PATH,
  ADMIN_DASHBOARD_PATH,
  CAMPUS_PATH,
  INSTITUTION_ADMINS_LIST_PATH,
  AFFILIATION_PATH,
  AWARD_PATH,
  EVENT_PATH,
  FACILITY_PATH,
  FACULTY_PATH,
  INSTITUTION_CATEGORIES_PATH,
  INSTITUTIONS_PATH,
  MILESTONE_PATH,
  NOTABLE_ALUMNUS_PATH,
  PARTNER_PATH,
  PARTNER_TYPES_PATH,
  PROGRAM_LEVELS_PATH,
  PUBLICATION_PATH,
  RESEARCH_AREA_PATH,
  RESEARCH_CENTRE_PATH,
  SESSIONS_PATH,
  SPECIALISATION_PATH,
  STUDENT_STATISTICS_PATH,
  TECHNOLOGY_INITIATIVE_PATH,
  POSITIONS_PATH,
  STAFF_PATH,
  INSTITUTION_PROFILE_PATH,
  PUBLICATION_TYPE_PATH,
  INSTITUTION_FOCUS_AREA_PATH,
  TITLE_PATH,
  INDUSTRY_COLLABORATION_PATH,
  OWNERSHIP_PATH,
  LICENSE_CATEGORIES_PATH,
  STAFF_STATISTICS_PATH,
  INSTITUTION_REPORT_PATH,
  FACILITIES_REPORT_PATH,
  STUDENTS_REPORT_PATH,
  STAFF_REPORT_PATH,
  PARTNERSHIPS_REPORT_PATH,
  ADMIN_PROFILE_PATH,
  GRAD_STATISTICS_PATH,
  GRADUATION_REPORT_PATH,
  AUDIT_TRAIL_PATH,
  STUDENT_CATEGORIES_PATH,
  SUPER_ADMINS_LIST_PATH,
} from "./AdminRoutes";
import ProgramLevel from "../../views/Admin/ProgramLevels";
import PartnerType from "../../views/Admin/PartnerType";
import Partner from "../../views/Admin/Partners";
import Session from "../../views/Admin/Session";
import Institution from "../../views/Admin/Institution";
import StudentStatistics from "../../views/Admin/StudentStatistics";
import ResearchArea from "../../views/Admin/ResearchArea";
import ResearchCentre from "../../views/Admin/ResearchCentre";
import AdminList from "../../views/Admin/AdminList";
import Campus from "../../views/Admin/Campus";
import Accreditations from "../../views/Admin/Accreditations";
import Facility from "../../views/Admin/Facilities";
import Award from "../../views/Admin/Award";
import Milestone from "../../views/Admin/Milestone";
import Faculty from "../../views/Admin/Faculty";
import TechnologyInitiative from "../../views/Admin/TechnologyInitiative";
import NotableAlumnus from "../../views/Admin/NotableAlumnus";
import Event from "../../views/Admin/Event";
import Affiliation from "../../views/Admin/Affiliations";
import Specialisation from "../../views/Admin/Specialisation";
import Publication from "../../views/Admin/Publication";
import AcademicProgram from "../../views/Admin/AcademicProgram";
import Position from "../../views/Admin/Position";
import Staff from "../../views/Admin/Staff";
import InstitutionProfile from "../../views/Admin/InstitutionProfile";
import PublicationType from "../../views/Admin/PublicationType";
import FocusArea from "../../views/Admin/FocusArea";
import Title from "../../views/Admin/Title";
import IndustryCollaboration from "../../views/Admin/IndustryCollaboration";
import Ownership from "../../views/Admin/Ownership";
import LicensingCategory from "../../views/Admin/LicensingCategory";
import StaffStatistics from "../../views/Admin/StaffStatistics";
import InstitutionsReport from "../../views/Admin/InstitutionsReport";
import FacilitiesReport from "../../views/Admin/FacilitiesReport";
import StudentReport from "../../views/Admin/StudentReport";
import StaffStatisticsReport from "../../views/Admin/StaffStatisticsReport";
import PartnershipReport from "../../views/Admin/PartnershipReport";
import Profile from "../../views/Admin/Profile";
import GraduationStatistics from "../../views/Admin/GraduationStatistics";
import GraduationStatisticsReport from "../../views/Admin/GraduationStatisticsReport";
import AuditTrail from "../../views/Admin/AuditTrail";
import StudentCategory from "../../views/Admin/StudentCategory";
import SuperAdminList from "../../views/Admin/SuperAdminList";
import ProtectedRoute from "../../components/Router/ProtectedRoute";
import { USER_ROLES } from "../../constants/roles";

export const AdminRouter = [
  {
    path: ADMIN_DASHBOARD_PATH,
    element: <AdminDashboard />,
  },

  {
    path: INSTITUTION_CATEGORIES_PATH,
    element: <InstitutionCategory />,
  },
  {
    path: ACCREDITING_BODIES_PATH,
    element: <AccreditingBody />,
  },

  {
    path: PROGRAM_LEVELS_PATH,
    element: <ProgramLevel />,
  },

  {
    path: PARTNER_TYPES_PATH,
    element: <PartnerType />,
  },

  {
    path: PARTNER_PATH,
    element: <Partner />,
  },

  {
    path: SESSIONS_PATH,
    element: <Session />,
  },

  {
    path: INSTITUTIONS_PATH,
    element: <Institution />,
  },

  {
    path: STUDENT_STATISTICS_PATH,
    element: <StudentStatistics />,
  },

  {
    path: RESEARCH_AREA_PATH,
    element: <ResearchArea />,
  },

  {
    path: RESEARCH_CENTRE_PATH,
    element: <ResearchCentre />,
  },

  {
    path: INSTITUTION_ADMINS_LIST_PATH,
    element: <AdminList />,
  },

  {
    path: CAMPUS_PATH,
    element: <Campus />,
  },

  {
    path: ACCREDITATIONS_PATH,
    element: <Accreditations />,
  },

  ACCREDITATIONS_PATH,

  {
    path: FACILITY_PATH,
    element: <Facility />,
  },

  {
    path: AWARD_PATH,
    element: <Award />,
  },

  {
    path: MILESTONE_PATH,
    element: <Milestone />,
  },

  {
    path: FACULTY_PATH,
    element: <Faculty />,
  },

  {
    path: TECHNOLOGY_INITIATIVE_PATH,
    element: <TechnologyInitiative />,
  },

  {
    path: NOTABLE_ALUMNUS_PATH,
    element: <NotableAlumnus />,
  },

  {
    path: EVENT_PATH,
    element: <Event />,
  },

  {
    path: AFFILIATION_PATH,
    element: <Affiliation />,
  },

  {
    path: ACADEMIC_PROGRAM_PATH,
    element: <AcademicProgram />,
  },

  {
    path: PUBLICATION_PATH,
    element: <Publication />,
  },

  {
    path: SPECIALISATION_PATH,
    element: <Specialisation />,
  },

  {
    path: POSITIONS_PATH,
    element: <Position />,
  },

  {
    path: STAFF_PATH,
    element: <Staff />,
  },

  {
    path: INSTITUTION_PROFILE_PATH,
    element: <InstitutionProfile />,
  },

  {
    path: PUBLICATION_TYPE_PATH,
    element: <PublicationType />,
  },

  {
    path: INSTITUTION_FOCUS_AREA_PATH,
    element: <FocusArea />,
  },

  {
    path: TITLE_PATH,
    element: <Title />,
  },

  {
    path: INDUSTRY_COLLABORATION_PATH,
    element: <IndustryCollaboration />,
  },

  {
    path: OWNERSHIP_PATH,
    element: <Ownership />,
  },
  {
    path: LICENSE_CATEGORIES_PATH,
    element: <LicensingCategory />,
  },

  {
    path: STAFF_STATISTICS_PATH,
    element: <StaffStatistics />,
  },

  {
    path: GRAD_STATISTICS_PATH,
    element: <GraduationStatistics />,
  },

  {
    path: INSTITUTION_REPORT_PATH,
    element: <InstitutionsReport />,
  },

  {
    path: FACILITIES_REPORT_PATH,
    element: <FacilitiesReport />,
  },
  {
    path: STUDENTS_REPORT_PATH,
    element: <StudentReport />,
  },

  {
    path: STAFF_REPORT_PATH,
    element: <StaffStatisticsReport />,
  },

  {
    path: PARTNERSHIPS_REPORT_PATH,
    element: <PartnershipReport />,
  },

  {
    path: GRADUATION_REPORT_PATH,
    element: <GraduationStatisticsReport />,
  },

  {
    path: ADMIN_PROFILE_PATH,
    element: <Profile />,
  },

  {
    path: ADMIN_PROFILE_PATH,
    element: <Profile />,
  },

  {
    path: AUDIT_TRAIL_PATH,
    element: (
      <ProtectedRoute role={[USER_ROLES.ADMIN]} element={<AuditTrail />} />
    ),
  },

  {
    path: STUDENT_CATEGORIES_PATH,
    element: <StudentCategory />,
  },

  {
    path: SUPER_ADMINS_LIST_PATH,

    element: (
      <ProtectedRoute role={[USER_ROLES.ADMIN]} element={<SuperAdminList />} />
    ),
  },
];
